<template>
  <svg
    id="Layer_1"
    data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 160 160"
    height="65px"
    width="65px"
    :style="'fill:' + color"
  >
    <g transform="rotate(90 90 90)">
      <path
        class="cls-1"
        d="M36.77,58.51v57.56a11.43,11.43,0,0,1-2,6.4,47,47,0,0,0,12,11.75,151.16,151.16,0,0,0,38,4.86,151,151,0,0,0,38.19-4.9,46.77,46.77,0,0,0,11.89-11.71,11.5,11.5,0,0,1-1.94-6.4V58.51a11.52,11.52,0,0,1,9.87-11.38A31,31,0,0,0,112.41,22H57.32A31,31,0,0,0,26.9,47.13,11.52,11.52,0,0,1,36.77,58.51Z"
      ></path>
      <rect class="cls-1" x="16.13" y="50.01" width="17.91" height="74.56" rx="8.5"></rect>
      <rect class="cls-1" x="136.22" y="50.01" width="17.91" height="74.56" rx="8.5"></rect>
      <path
        class="cls-1"
        d="M147.38,138.19l.17.42.18.42a7.8,7.8,0,0,1-.34,6.62,9.92,9.92,0,0,1-5.6,4.73A172,172,0,0,1,85.08,160a172,172,0,0,1-56.71-9.61,10,10,0,0,1-5.6-4.73,7.8,7.8,0,0,1-.33-6.62l.17-.42.17-.42a8.47,8.47,0,0,1,4.74-4.57,9.6,9.6,0,0,1,6.75-.15,154.21,154.21,0,0,0,50.81,8.61,154.16,154.16,0,0,0,50.81-8.61,9.6,9.6,0,0,1,6.75.15A8.47,8.47,0,0,1,147.38,138.19Z"
      ></path>
    </g>
    <text
      v-if="seatName"
      fill="#ffffff"
      :font-size="seatName.length > 2 ? '55px' : '70px'"
      font-family="Roboto"
      :x="seatName.length > 2 ? '55' : seatName.length > 1 ? '55' : '75'"
      :y="seatName.length > 2 ? '105' : '110'"
      :style="pointer ? 'cursor: pointer' : 'cursor: not-allowed'"
      @click="pointer ? clickSeat() : '' "
    >{{ seatName ? seatName : "" }}</text>
  </svg>
</template>

<script>
export default {
  props: ["seatName", "color", "pointer"],
  data() {
    return {};
  },
  methods: {
    clickSeat() {
      console.log("Emit Click Seat");
      this.$emit("clickSeat");
    }
  }
};
</script>
